import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const SaveIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const {
      tooltipTitle = t('common.save', 'Save'),
      ...buttonProps
    } = props;

    return (
      <IconButton
        ref={ref}
        {...buttonProps}
        tooltipTitle={tooltipTitle}
      >
        <CheckIcon color={props.color === 'primary' ? 'inherit' : 'error'} />
      </IconButton>
    );
  },
);

SaveIconButton.displayName = 'SaveIconButton';
export default SaveIconButton;
